module.exports = __webpack_public_path__ + "static/img/3.ec7a287.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/eng/3.png
// module id = UU+J
// module chunks = 0